import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  overspendIndicator: {
    fontWeight: 'bold',
    textAlign: 'center',
    color: theme.palette.common.white,

    '& h6':{
      fontWeight: 'bold',
    }
  },
}));

